import { Component } from '@angular/core';
import { ErrorCodeComponent } from '@shared/components/error-code/error-code.component';

@Component({
  selector: 'app-page404',
  imports: [ErrorCodeComponent],
  templateUrl: './page404.html',
  styleUrl: './page404.scss',
  standalone: true,
})
export class Page404 {}
